{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Valitse kohde",
  "tableResizer": "Koon muuttaja",
  "colorSwatchPicker": "Color swatches"
}
